import React, { memo } from 'react';
import Radium from 'radium';
import { WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { questionsPropTypes } from 'types/accountTypes';

import styles from './styles.module.scss';

const AccountRelationshipValidation = ({ questions }) => (
  <UTForm fields={questions} formClasses={{ formContainer: styles.form }} />
);

AccountRelationshipValidation.propTypes = {
  questions: questionsPropTypes
};

export default WithLoading(props => props.loading)(memo(Radium(AccountRelationshipValidation)));
